/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */


import jsonata from 'jsonata';

export const processExpression = async (formula: string, data: unknown, bindings?: Record<string, any>) => {
  return jsonata(formula, { recover: true }).evaluate(data, bindings);
}
